import { createFileRoute } from '@tanstack/react-router'
import Login from '../pages/Login/Login'
import AuthLayout from '../layouts/AuthLayout'

export const Route = createFileRoute('/login')({
  component: LoginComponent,
})

function LoginComponent() {
  return (
    <AuthLayout>
      <Login />
    </AuthLayout>
  )
}
